import { createApp } from 'vue';
import Vuelidate from '@vuelidate/core';
// import VueScrollTo from 'vue-scrollto';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/scss/main.scss';
import { createGtm } from '@gtm-support/vue-gtm';
// import VCalendar from 'v-calendar';
import App from './App.vue';
import axios from './plugins/axios';
// import './registerServiceWorker';
import router from './router';
import store from './store';

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(Vuelidate);
// app.use(VueScrollTo);

// Google Tag Manager設定
app.use(createGtm({
  id: 'GTM-5VD75PHH',
  vueRouter: router,
  debug: process.env.NODE_ENV !== 'production',
  enabled: true,
  loadScript: true,
  defer: false,
}));

// app.use(VCalendar, {});
app.mount('#app');
